<template>
  <div class="tops">
    <div class="tops__container">
      <div
        v-for="(category, index) in categories"
        :key="category.id"
        class="tops__container__menu"
        :class="{ 'is-last-and-odd': booleanAreCategoriesOdd && index === categories.length - 1 }"
      >
        <div>
          <Menu
            :logo="logo"
            :header="headerStyles"
            :bluer="category.bluer"
            :header2="header2Styles"
            :is-premium-user="!!getUser"
            :interiors="headerinteriors"
            :categories="category.categories"
            :category="category"
            :season="getSeasonSelected || menuSeason"
            :position="index"
            :is-cup="isCup"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Sections/Top/MenuV2';
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
  name: 'TopsV2',
  components: {
    Menu,
  },
  props: {
    season: {
      type: Number,
      default: 1401,
    },
    custom: {
      type: Object,
      default: null,
    },
    /**
     * Indicates if must await for the season prop, or not to get tops data,
     * if not, tournaments will be fetched to get a default season
     * {boolean} awaitForSeasons
     */
    awaitForSeason: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCup: false,
      arrayCategories: [
        { id: 1, name: 'Goles', bluer: false, categories: [12], coordinatePoint: 2 },
        { id: 2, name: 'Pases acertados', bluer: false, categories: [2, 20], coordinatePoint: 3 },
        { id: 23, name: 'Tiros de Esquina', bluer: false, categories: [31, 32], coordinatePoint: 1 },
        { id: 3, name: 'Balones recuperados en disputa', bluer: false, categories: [483], coordinatePoint: 1 },
        { id: 4, name: 'Asistencias', bluer: false, categories: [10], coordinatePoint: 2 },
        { id: 5, name: 'Participaciones en gol', bluer: false, categories: [27], coordinatePoint: 1 },
        { id: 6, name: 'Tiros a gol', bluer: false, categories: [510], coordinatePoint: 2 },
        {
          id: 7,
          name: 'Tiros a gol que llegaron a la portería',
          bluer: false,
          categories: [537, 540, 544, 547],
          coordinatePoint: 2,
        },
        { id: 8, name: 'Cabeceos en área rival', bluer: false, categories: [328], coordinatePoint: 3 },
        {
          id: 9,
          name: 'Cabeceos en área propia',
          bluer: false,
          categories: [231, 280, 238, 287, 406, 294],
          coordinatePoint: 3,
        },
        { id: 10, name: 'Centros', bluer: false, categories: [13, 25], coordinatePoint: 2 },
        {
          id: 11,
          name: 'Centros acertados',
          bluer: false,
          categories: [98, 101, 104, 105, 109, 112, 115, 116],
          coordinatePoint: 2,
        },
        { id: 12, name: '1vs1 exitosos ofensivo', bluer: false, categories: [4], coordinatePoint: 1 },
        {
          id: 13,
          name: '1vs1 exitosos ofensivo que terminaron en gol',
          bluer: false,
          categories: [88],
          coordinatePoint: 1,
        },
        { id: 14, name: '1vs1 defensivos exitoso', bluer: false, categories: [5], coordinatePoint: 1 },
        { id: 15, name: 'Rechaces', bluer: false, categories: [34], coordinatePoint: 1 },
        { id: 16, name: 'Balones ganados en área propia', bluer: false, categories: [23], coordinatePoint: 1 },
        { id: 17, name: 'Balones ganados en área rival', bluer: false, categories: [11], coordinatePoint: 1 },
        { id: 18, name: 'Faltas cometidas', bluer: false, categories: [17], coordinatePoint: 3 },
        { id: 19, name: 'Faltas recibidas', bluer: false, categories: [18], coordinatePoint: 3 },
        { id: 20, name: 'Tarjetas amarillas', bluer: false, categories: [14], coordinatePoint: 3 },
        { id: 21, name: 'Tarjetas rojas', bluer: false, categories: [15], coordinatePoint: 3 },
        { id: 22, name: 'Atajadas', bluer: false, categories: [39], coordinatePoint: 1 },
      ],
      menuSeason: 0,
      tournamentsUrl: 'https://17zyhpyc7c.execute-api.us-west-2.amazonaws.com/prod/tournaments',
    };
  },
  watch: {
    seasonId(newValue) {
      if (newValue) {
        this.menuSeason = Number(newValue);
      }
    },
    getTournamentSelected(newValue) {
      this.isCup = newValue === 33;
    },
  },
  computed: {
    ...mapGetters('loginGeneral', ['getUser', 'getTournamentSelected', 'getSeasonSelected', 'seasonId']),
    booleanAreCategoriesOdd() {
      return this.categories.length % 2 === 1;
    },
    categories() {
      var response = [];
      if (this.$route.query.categories) {
        var queryCategories = this.$route.query.categories.split(',');
        var numCategories = queryCategories.map(Number);
        response = this.arrayCategories.filter(function(e) {
          return this.indexOf(e.id) >= 0;
        }, numCategories);
      } else {
        if (this.custom != null) {
          if (Object.keys(this.custom).length > 0) {
            if (this.custom.categories == 'all') {
              response = this.arrayCategories;
            } else {
              var queryCategoriesCustom = this.custom.categories.split(',');
              var numCategoriesCustom = queryCategoriesCustom.map(Number);
              response = this.arrayCategories.filter(function(e) {
                return this.indexOf(e.id) >= 0;
              }, numCategoriesCustom);
            }
          } else {
            response = this.arrayCategories;
          }
        } else {
          response = this.arrayCategories;
        }
      }
      return response;
    },
    logo() {
      if (this.$route.query.logo) {
        return this.$route.query.logo;
      } else {
        if (this.custom != null) {
          if (Object.keys(this.custom).length) {
            return this.custom.logo;
          } else {
            return 'https://golstatsimages.blob.core.windows.net/content/shieldLogoPc.png';
          }
        } else {
          return 'https://golstatsimages.blob.core.windows.net/content/shieldLogoPc.png';
        }
      }
    },
    headerinteriors() {
      if (this.custom != null) {
        if (Object.keys(this.custom).length) {
          return {
            color: this.custom.colorheader,
            background: this.custom.subHeaderBackground,
          };
        } else {
          return {
            color: this.$route.query.colorheader || '#132839',
            background: this.$route.query.backgroundheader || '#cce8b5',
          };
        }
      } else {
        return {
          color: this.$route.query.colorheader || '#132839',
          background: this.$route.query.backgroundheader || '#cce8b5',
        };
      }
    },
    headerStyles() {
      if (this.custom != null) {
        if (Object.keys(this.custom).length) {
          return {
            color: this.custom.headerColor,
            background: this.custom.headerBackground,
            borderColor: this.custom.headerBorderColor,
          };
        } else {
          return {
            color: this.$route.query.headerColor || '#fff',
            background: this.$route.query.headerBackground || '#242424',
            borderColor: this.$route.query.headerBorderColor || '#88da69',
          };
        }
      } else {
        return {
          color: this.$route.query.headerColor || '#fff',
          background: this.$route.query.headerBackground || '#242424',
          borderColor: this.$route.query.headerBorderColor || '#88da69',
        };
      }
    },
    header2Styles() {
      if (this.custom != null) {
        if (Object.keys(this.custom).length) {
          return {
            color: this.custom.header2Color,
            background: this.custom.header2Background,
          };
        } else {
          return {
            color: this.$route.query.header2Color || '#fff',
            background: this.$route.query.header2Background || '#3b3b3b',
          };
        }
      } else {
        return {
          color: this.$route.query.header2Color || '#fff',
          background: this.$route.query.header2Background || '#3b3b3b',
        };
      }
    },
  },
  methods: {
    /**
     * @author Alejandro Martinez
     * @param {number} retries
     * @return {Promise<any|undefined>}
     */
    async fetchTournaments(retries) {
      try {
        const { data } = await axios.get(this.tournamentsUrl);
        return data;
      } catch (e) {
        if (retries > 0) {
          return this.fetchTournaments(retries - 1);
        }
        throw new Error(e);
      }
    },
  },
  async created() {
    try {
      this.menuSeason = Number(this.seasonId);
      this.isCup = !!this.$route.query.isCup;
      // if (!this.awaitForSeason) {
      //   this.menuSeason = this.seasonId;
      // } else {
      //   this.menuSeason = this.seasonId;
      // }
    } catch (e) {
      throw new Error(e);
    }
  },
};
</script>
<style lang="scss" scoped>
.tops {
  padding-bottom: 30px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  &__container {
    height: 100%;
    width: 100%;
    max-width: 1270px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 40px;
    row-gap: 30px;

    &__menu {
      & > div {
        width: 100%;
      }

      &.is-last-and-odd {
        display: flex;
        justify-content: center;
        grid-column-start: 1;
        grid-column-end: 3;

        & > div {
          max-width: 613px;
        }
      }
    }
  }

  @media screen and (max-width: 1218px) {
    &__container {
      padding: 0 2em;
      grid-template-columns: 1fr;
      &__menu {
        &.is-last-and-odd {
          grid-column-start: 1;
          grid-column-end: 2;

          & > div {
            max-width: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 620px) {
    &__container {
      padding: 0 4px;
    }
  }
}
</style>
